module.exports = __webpack_public_path__ + "app-static/img/py.414de4a4.png";